/* Core & libraries */
import React, {useEffect, useRef, useState} from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { FOP_SERVICE_URL } from "../../constants/appConstants";
import { useHasPermission } from '../../hooks/useHasPermission';

/* Components */

/* Styles */
import styles from "./styles.js"


const FOPIframe = ({paymentToken, callback, setShowModal}) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const iframeRef = useRef(null);
  const { checkPermission } = useHasPermission();


  const handleIframeData = async (event) => {
    // Check the origin of the message to ensure it's coming from a trusted source
    if (event.origin !== FOP_SERVICE_URL) return;
    if (event?.data && event?.data?.success) {
      switch (event?.data?.type) {
        case "getToken":
          iframeRef.current.contentWindow.postMessage({
            token: paymentToken,
            editPermission: checkPermission("F_EDIT_PAYMENT_DETAILS"),
          }, FOP_SERVICE_URL);
          break;
        case "submit":
          await callback(event, "", "")
          setShowModal(false)
          break;
        case "cancel" :
          setShowModal(false)
          break;
        case "resize" :
          iframeRef.current.style.height = event?.data?.height + "px"
          break;
      }
    }
  }

  useEffect(() => {
    if (paymentToken) {
      window.addEventListener('message', handleIframeData);
      return () => {
        // Cleanup: remove the event listener when component unmounts
        window.removeEventListener('message', handleIframeData);
      };
    }
  }, [paymentToken]);

  return (
    paymentToken &&
      <iframe className={classes.iframe} ref={iframeRef} src={`${FOP_SERVICE_URL}/app?parentOrigin=${encodeURIComponent(window.location.origin)}`} id={"iframe"}></iframe>
  )
}

export default FOPIframe;
